import i18next from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      // General translations
      welcome: "Welcome to New Brindha Matrimony",
      findYourPartner: "Find Your Perfect Partner Today!",
      languageSelectSubtitle: "Choose your preferred language to continue",
      languages: {
        english: "English",
        tamil: "Tamil",
      },

      // Footer.jsx translations
      title: "Matrimony",
      tagline: "Connecting hearts since 2024.",
      copyright: "All rights reserved.",
      links: {
        home: "Home",
        favourites: "Favourites",
        matchProfiles: "Match Profiles",
      },
      followUs: "Follow Us",
      madeWith: "Made with ❤️ by NewBrindha Team",

      // HowItWorking.jsx translations
      howItWorks: "How It Works",
      subtitle:
        "Your journey to finding the perfect life partner in four simple steps",
      steps: [
        {
          title: "1. Register for Free",
          description:
            "Create your profile easily with your personal and family details. It takes just a few minutes to join our trusted community.",
          icon: "📝",
        },
        {
          title: "2. Find Your Match",
          description:
            "Browse through thousands of verified profiles and use our advanced filters to find your perfect life partner based on your preferences.",
          icon: "🔍",
        },
        {
          title: "3. Connect & Chat",
          description:
            "Express interest and chat securely within our encrypted platform to get to know your match better with complete privacy.",
          icon: "💬",
        },
        {
          title: "4. Meet & Marry",
          description:
            "Take the next step towards marriage with confidence. Our team provides guidance and support throughout your journey.",
          icon: "💍",
        },
      ],
      ctaTitle: "Ready to Begin Your Journey?",
      ctaButton: "Create Your Profile Now",
      signIn: "Sign In",
      viewMatches: "View Matching Profiles",
      scrollDown: "Scroll down",

      // ConnectionRequests.jsx translations
      connectionRequests: "Connection Requests",
      receivedRequests: "Received Requests",
      sentRequests: "Sent Requests",
      years: "years",
      acceptRequest: "Accept Request",
      rejectRequest: "Reject Request",
      blockUser: "Block User",
      cancelRequest: "Cancel Request",
      sendRequest: "Send Request",
      sendConnectionRequest: "Send Connection Request",
      requestAccepted: "Request accepted!",
      requestRejected: "Request rejected!",
      userBlocked: "User blocked!",
      requestCanceled: "Request canceled!",
      requestSent: "Request sent!",
      reportReason: "Report Reason",
      submitReport: "Submit Report",
      cancel: "Cancel",
      favorites: "Favourites",
      approved: "Approved",
      pending: "Rejected",
      viewed: "Viewed",

      form: {
        name: "Name",
        message: "Message",
        nativeLanguage: "Native Language",
        cancel: "Cancel",
        send: "Send",
      },

      // Favourites.jsx translations
      loadingProfiles: "Loading profiles...",
      rechargePoints: "Recharge Points",
      points: "Points",
      // Points translations
      points: {
        pointstitle: "Points",
        rechargePoints: "Recharge Points",
        pointsHistory: "Points History",
        matrimonyId: "Matrimony ID",
        profileName: "Profile Name",
        pointsSpent: "Points Spent",
        noSpendHistory: "No spent history found.",
        rechargeSuccess: "🎉 Recharged Successfully! Check your Points ✨",
        selectAmount: "Select Amount",
        proceedToPayment: "Proceed to Payment",
        selectAmountPlaceholder: "Select amount",
        amountOptions: {
          200: "200",
          500: "500",
          1000: "1000",
        },
      },
      searchPlaceholder: "Search Here...",
      ageFilter: "Age",
      casteFilter: "Caste",
      locationFilter: "Location",
      sortBy: "Sort By",
      sortAZ: "A - Z",
      sortZA: "Z - A",
      profileDetails: "Profile Details",
      notSpecified: "Not specified",
      personalDetails: "Personal Details",
      name: "Name",
      matrimonyId: "Matrimony ID",
      age: "Age",
      gender: "Gender",
      dateOfBirth: "Date of Birth",
      height: "Height",
      weight: "Weight",
      email: "Email",
      phone: "Phone Number",
      motherTongue: "Mother Tongue",
      native: "Native",
      religion: "Religion",
      caste: "Caste",
      subCaste: "Sub Caste",
      bloodGroup: "Blood Group",
      familyProfessionalDetails: "Family & Professional Details",
      fatherName: "Father's Name",
      motherName: "Mother's Name",
      fatherOccupation: "Father's Occupation",
      motherOccupation: "Mother's Occupation",
      siblingCount: "Sibling Count",
      occupation: "Occupation",
      annualIncome: "Annual Income",
      education: "Education",
      company: "Company",
      workLocation: "Work Location",
      workCountry: "Work Country",
      horoscopeDetails: "Horoscope Details",
      nakshatra: "Nakshatra",
      rashi: "Rashi",
      ascendent: "Ascendent",
      birthTime: "Birth Time",
      birthPlace: "Birth Place",
      preferences: "Preferences",
      preferredAgeRange: "Preferred Age Range",
      preferredHeightRange: "Preferred Height Range",
      preferredReligion: "Preferred Religion",
      preferredCaste: "Preferred Caste",
      preferredSubCaste: "Preferred Sub Caste",
      preferredStatus: "Preferred Status",
      preferredLocation: "Preferred Location",
      documents: "Documents",
      viewHoroscopeDocument: "View Horoscope Document {index}",
      noHoroscopeDocuments: "No horoscope documents available.",
      contactUs: "Contact Us",
      sendMessage: "Send Message",
      contact: {
        placeholders: {
          name: "Enter your name",
          email: "Enter your email",
          description: "Enter your message",
          mobile: "Enter your mobile number",
        },
        errors: {
          nameRequired: "Name is required",
          mobileRequired: "Mobile number is required",
          mobileInvalid: "Mobile number must be 10 digits",
          emailRequired: "Email is required",
          emailInvalid: "Invalid email address",
          descriptionRequired: "Description is required",
        },
      },
      insufficientPoints:
        "You have insufficient points to visit this profile. To unlock this profile, please recharge points!",
      goToRecharge: "Go to recharge",
      fetchFavoritesError: "Failed to fetch favorite profiles",
      pointsSpentSuccess: "Points spent successfully! Profile unlocked.",
      pointsSpentError: "Spend Points Error: {error}",
      fetchPointsError: "Error fetching points",
      moreDetails: "More Details",
      viewDetails: "View Details",
      viewed: "Viewed",
      compatible : "Compatible",
      location: "Location",
      systemMatchedByNakshatra: "System Matched Profiles by Nakshatra",
      

      // Navbar translations
      home: "Home",
      matchingProfiles: "Matching Profiles",
      favourites: "Favourites",
      aboutus: "About Us",
      howits: "How It Works",
      contactUs: "Contact Us",
      logout: "Logout",
      settings: "Settings",
      settings: {
        settingstitle: "Settings",
        profileSettings: "Profile Settings",
        name: "Name",
        enterName: "Enter your name",
        email: "Email",
        enterEmail: "Enter your email",
        updateProfile: "Update Profile",
        notificationSettings: "Notification Settings",
        emailNotifications: "Email Notifications",
        pushNotifications: "Push Notifications",
        securitySettings: "Security Settings",
        changePassword: "Change Password",
        newPassword: "New Password",
        enterNewPassword: "Enter new password",
        confirmPassword: "Confirm Password",
        confirmPasswordPlaceholder: "Re-enter your password",
        updatePassword: "Update Password",
        languageSettings: "Language Settings",
        selectLanguage: "Select Language",
        currentLanguage: "Current Language",
        passwordMismatch: "Passwords do not match",
        profileUpdateSuccess: "Profile updated successfully",
        profileUpdateError: "Failed to update profile",
        passwordUpdateSuccess: "Password updated successfully",
        passwordUpdateError: "Failed to update password",
      },
      myProfile: "My Profile",
      contactFormSuccess: "Contact form submitted successfully",
      contactFormError: "Failed to submit contact form",

      // Dashboard translations
      fetchProfilesError: "Failed to fetch profiles",
      fetchPreferencesError: "Failed to fetch preference profiles",
      fetchLocationPreferencesError:
        "Failed to fetch location preference profiles",
      reportSuccess: "Profile reported successfully",
      reportError: "Failed to report profile",
      noProfilesFound: "No profiles found",
      reportReasonPlaceholder:
        "Please provide a reason for reporting this profile",
      report: "Report",
      reportProfile: "Report Profile",
      newProfiles: "New Profiles",
      allProfiles: "All Profiles",
      preferenceByRashi: "Preference by Nakshatra",
      preferenceByLocation: "Preference by Location",
      defaultProfiles: "Default Profiles",
      favoriteUpdateError: "Failed to update favorites",
      backToHome: "Back to Home",

      // AboutUs translations
      about: {
        title: "About NBS",
        welcome:
          "Welcome to New Brindha Studio, where tradition meets technology. As a leading matrimony platform, we are committed to helping you find the perfect life partner with trust, transparency, and simplicity.",
        missionVision: "Our Mission & Vision",
        mission:
          "Our mission is to provide a secure, user-friendly, and culturally rich matchmaking platform that fosters lifelong relationships. We believe in the sacred bond of marriage and strive to make every connection meaningful.",
        vision:
          "Our vision is to become the most trusted name in the matrimonial industry by continuously innovating and delivering value to our members.",
        whyChoose: "Why Choose NBS?",
        features: {
          verifiedProfiles: {
            title: "Verified Profiles",
            desc: "Every profile is thoroughly verified to ensure safety and authenticity for all our users.",
          },
          communityFocused: {
            title: "Community-Focused",
            desc: "We specialize in community and religion-based matches to help you find a culturally compatible partner.",
          },
          globalReach: {
            title: "Global Reach",
            desc: "Whether you're in India or abroad, NBS connects you to potential partners worldwide.",
          },
          personalizedSupport: {
            title: "Personalized Support",
            desc: "Our dedicated support team is always ready to assist you on your journey to find your soulmate.",
          },
        },
        coreValues: "Our Core Values & Vision",
        coreValuesText:
          "At NBS Matrimony, we are driven by a clear purpose — to bring people together through trust, integrity, and genuine connections. Our vision goes beyond matchmaking; we aim to build a future where finding a life partner is an empowering and joyful journey.",
        valuesList: {
          integrity:
            "Integrity First: We uphold honesty and transparency in everything we do.",
          customerCentric:
            "Customer-Centric Approach: Your happiness is our top priority, and our team is always ready to assist you.",
          innovation:
            "Innovation & Growth: We continuously evolve to offer smarter tools and a seamless user experience.",
        },
        testimonials: "What Our Users Say",
        testimonialsData: {
          testimonial1: {
            text: "Thanks to NBS, I found my soulmate within 3 months. The platform is clean, secure, and very user-friendly!",
            author: "Ajeeth & Shivani, Bangalore.",
          },
          testimonial2: {
            text: "We met through NBS and connected instantly. Their matchmaking system is genuinely effective and respectful of privacy.",
            author: "Praveen & Suji, Chennai.",
          },
          testimonial3: {
            text: "After trying many platforms, NBS stood out with its clean design and genuine profiles. We're forever thankful!",
            author: "Sri & Praveen, Coimbatore.",
          },
        },
        ctaTitle: "Ready to Begin Your Journey?",
        ctaText:
          "Join NBS today and take the first step toward finding your perfect match.",
      },

      // ChatWidget translations
      chat: {
        title: "Admin Chat",
        loginPrompt: "Please login to access chat",
        welcomeMessage: "Welcome! Send a message to chat with our admin.",
        inputPlaceholder: "Type your message...",
        connectionStatus: {
          connected: "Connected",
          connecting: "Connecting...",
          error: "Reconnecting...",
          disconnected: "Disconnected",
        },
      },

      // LoginForm.jsx translations
      loginMessage: "Log in to find your perfect match",
      matrimonyId: "Matrimony ID",
      matrimonyIdPlaceholder: "Enter your Matrimony ID",
      password: "Password",
      passwordPlaceholder: "Enter your password",
      loginButton: "Login",
      noAccount: "Don't have an account?",
      register: "Register",
      successMessage: "Login successful! Redirecting...",
      errorMessage: "Please check the Matrimony ID or password and try again.",
      formError: "Please fix the errors in the form.",
      close: "Close",
      switchLanguage: "Switch Language",
      mobileLogin: "Login Via Mobile Number",
      passwordRequired: "Password is required",
      invalidPassword:
        "Password must be at least 8 characters with letters and numbers",
      matrimonyIdRequired: "Matrimony ID is required",
      invalidMatrimonyId: "Invalid Matrimony ID",
      forgotPassword: "Forgot Password?",
      resetPassword: "Reset Password",
      backToLogin: "Back to Login",
      email: "Email",
      emailPlaceholder: "Enter your email",
      emailRequired: "Email is required",
      invalidEmail: "Invalid email address",
      newPassword: "New Password",
      newPasswordPlaceholder: "Enter new password",
      confirmPassword: "Confirm Password",
      confirmPasswordPlaceholder: "Re-enter your password",
      passwordsNotMatch: "Passwords do not match",
      verifyEmail: "Verify Email",
      emailVerifiedMessage: "Email verified! Please enter your new password.",
      emailNotRegistered: "This email is not registered",
      passwordResetSuccess: "Password reset successfully!",
      passwordMismatch: "Passwords do not match",
      passwordResetError: "Error resetting password",
      emailVerifySuccess: "Email verified successfully!",

      // MobileVerification.jsx translations
      mobileVerification: "Mobile Verification",
      enterFullName: "Enter Full Name",
      enterMobileNumber: "Enter Mobile Number",
      verifyMobile: "Verify Mobile",
      resendOtp: "Resend OTP",
      enterOtp: "Enter OTP",
      submitOtp: "Submit OTP",
      otpSent: "OTP sent to your mobile number!",
      mobileVerified: "Mobile number verified successfully! 🎉",
      invalidMobile: "Please enter a valid 10-digit mobile number",
      invalidOtp: "Please enter a valid 4-digit OTP",
      errorFullName: "Please enter your full name",
      errorMobileNumber: "Please enter a valid 10-digit mobile number",
      otpFailed: "Failed to send OTP",
      tryAgain: "Please try again.",
      otpError: "Error sending OTP. Please try again.",
      alreadyHaveAccount: "Already have an account?",
      login: "Login",
      tagline: "People searching for their partner",
      loading: "Loading...",

      confirmPointsSpend: "Confirm Points Spend",
      spendPointsMessage:
        "Do you want to spend 500 points to view this profile?",
      noThanks: "No thanks",
      confirm: "Confirm",
      pointsDeductionWarning:
        "This action will deduct {points} points from your balance.",
      viewAll: "View All",

      sortAgeAsc: "Age (Low to High)", // Added
      sortAgeDesc: "Age (High to Low)",

      profileDetails: {
        profileDetails: "Profile Details",
        education: "Education",
        ageGender: "Age & Gender",
        about: "About",
        aboutDescription:
          "Hi there! I'm {{full_name}}, a caring and family-oriented individual who believes in the power of love and togetherness. I'm {{age}} Years Old. I enjoy the little things in life, from sharing a cup of coffee with family to taking on new adventures with someone special. I'm looking forward to meeting a partner who shares the same values, and together we can build a future filled with love and happiness.",
        notSpecified: "Not specified",
        noInfo: "No additional information available.",
        close: "Close",
        language: "Language",
        noProfileData: "No profile data found.",
        // Added keys for profile actions
        active: "Active",
        deactive: "Deactive",
        deactivateReason: "Reason for Deactivation",
        deactivateProfile: "Deactivate Profile",
        deleteProfile: "Delete Profile",
        deleteConfirm:
          "Are you sure you want to delete your profile? This action cannot be undone.",
        deleteError: "Failed to delete profile",
        editPartnerPreferences: "Edit Partner Preferences",
        savePreferences: "Save Preferences",
        editPersonalInformation: "Edit Personal Information",
        saveInformation: "Save Information",
        reasonRequired: "Deactivation reason is required",
        male: "Male",
        female: "Female",
        photo: "Profile Photo",
      },
    },
  },
  ta: {
    translation: {
      // General translations
      welcome: "நியூ பிருந்தா மேட்ரிமோனிக்கு வரவேற்கிறோம்",
      findYourPartner: "இன்று உங்கள் சரியான துணையை கண்டறியவும்!",
      languageSelectSubtitle:
        "தொடர உங்கள் விருப்பமான மொழியைத் தேர்ந்தெடுக்கவும்",
      languages: {
        english: "ஆங்கிலம்",
        tamil: "தமிழ்",
      },

      // Footer.jsx translations
      title: "திருமணம்",
      tagline: "2024 முதல் இதயங்களை இணைக்கிறது.",
      copyright: "அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.",
      links: {
        home: "முகப்பு",
        favourites: "பிடித்தவை",
        matchProfiles: "பொருத்தமான சுயவிவரங்கள்",
      },
      followUs: "எங்களைப் பின்தொடரவும்",
      madeWith: "நியூபிருந்தா குழுவால் ❤️ உருவாக்கப்பட்டது",

      // HowItWorking.jsx translations
      howItWorks: "இது எப்படி வேலை செய்கிறது",
      subtitle:
        "சரியான வாழ்க்கைத் துணையைக் கண்டுபிடிப்பதற்கான உங்கள் பயணம் நான்கு எளிய படிகளில்",
      steps: [
        {
          title: "1. இலவசமாக பதிவு செய்யவும்",
          description:
            "உங்கள் தனிப்பட்ட மற்றும் குடும்ப விவரங்களுடன் உங்கள் சுயவிவரத்தை எளிதாக உருவாக்கவும். நம்பகமான சமூகத்தில் சேர சில நிமிடங்கள் மட்டுமே ஆகும்.",
          icon: "📝",
        },
        {
          title: "2. உங்கள் பொருத்தத்தைக் கண்டறியவும்",
          description:
            "ஆயிரக்கணக்கான சரிபார்க்கப்பட்ட சுயவிவரங்களை உலாவி, உங்கள் விருப்பத்தேர்வுகளின் அடிப்படையில் உங்கள் சரியான வாழ்க்கைத் துணையைக் கண்டறிய மேம்பட்ட வடிகட்டிகளைப் பயன்படுத்தவும்.",
          icon: "🔍",
        },
        {
          title: "3. இணைந்து உரையாடவும்",
          description:
            "ஆர்வத்தை வெளிப்படுத்தவும், முழுமையான தனியுரிமையுடன் உங்கள் பொருத்தத்தை நன்றாக அறிந்துகொள்ள எங்கள் மறைகுறியாக்கப்பட்ட தளத்திற்குள் பாதுகாப்பாக அரட்டையடிக்கவும்.",
          icon: "💬",
        },
        {
          title: "4. சந்தித்து திருமணம் செய்யவும்",
          description:
            "தன்னம்பிக்கையுடன் திருமணத்தை நோக்கி அடுத்த கட்டத்தை எடுக்கவும். உங்கள் பயணம் முழுவதும் எங்கள் குழு வழிகாட்டல் மற்றும் ஆதரவை வழங்குகிறது.",
          icon: "💍",
        },
      ],
      ctaTitle: "உங்கள் பயணத்தைத் தொடங்க தயாரா?",
      ctaButton: "இப்போதே உங்கள் சுயவிவரத்தை உருவாக்கவும்",
      signIn: "உள்நுழைய",
      viewMatches: "பொருந்தும் சுயவிவரங்களைக் காண்க",
      scrollDown: "கீழே உருட்டவும்",

      // ConnectionRequests.jsx translations
      connectionRequests: "இணைப்பு கோரிக்கைகள்",
      receivedRequests: "பெறப்பட்ட கோரிக்கைகள்",
      sentRequests: "அனுப்பப்பட்ட கோரிக்கைகள்",
      years: "ஆண்டுகள்",
      acceptRequest: "கோரிக்கையை ஏற்கவும்",
      rejectRequest: "கோரிக்கையை நிராகரிக்கவும்",
      blockUser: "பயனரைத் தடுக்கவும்",
      compatible : "பொருந்தும்",
      cancelRequest: "கோரிக்கையை ரத்து செய்யவும்",
      sendRequest: "கோரிக்கையை அனுப்பவும்",
      sendConnectionRequest: "இணைப்பு கோரிக்கையை அனுப்பவும்",
      requestAccepted: "கோரிக்கை ஏற்கப்பட்டது!",
      requestRejected: "கோரிக்கை நிராகரிக்கப்பட்டது!",
      userBlocked: "பயனர் தடுக்கப்பட்டார்!",
      requestCanceled: "கோரிக்கை ரத்து செய்யப்பட்டது!",
      requestSent: "கோரிக்கை அனுப்பப்பட்டது!",
      form: {
        name: "பெயர்",
        message: "செய்தி",
        nativeLanguage: "தாய்மொழி",
        cancel: "ரத்து செய்யவும்",
        send: "அனுப்பவும்",
      },

      // Favourites.jsx translations
      systemMatchedByNakshatra:"நட்சத்திரத்தின் அடிப்படையில் கணினி பொருத்தமான வரன்கள்",
      loadingProfiles: "சுயவிவரங்கள் ஏற்றப்படுகின்றன...",
      rechargePoints: "ரீசார்ஜ் புள்ளிகள்",
      points: "புள்ளிகள்",
      points: {
        pointstitle: "புள்ளிகள்",
        rechargePoints: "புள்ளிகளை மறுசார்ஜ் செய்யவும்",
        pointsHistory: "புள்ளிகள் வரலாறு",
        matrimonyId: "திருமண ஐடி",
        profileName: "சுயவிவர பெயர்",
        pointsSpent: "செலவிடப்பட்ட புள்ளிகள்",
        noSpendHistory: "செலவு வரலாறு எதுவும் கிடைக்கவில்லை.",
        rechargeSuccess:
          "🎉 வெற்றிகரமாக மறுசார்ஜ் செய்யப்பட்டது! உங்கள் புள்ளிகளை சரிபார்க்கவும் ✨",
        selectAmount: "தொகையைத் தேர்ந்தெடுக்கவும்",
        proceedToPayment: "கட்டணத்திற்கு தொடரவும்",
        selectAmountPlaceholder: "தொகையைத் தேர்ந்தெடுக்கவும்",
        amountOptions: {
          200: "200",
          500: "500",
          1000: "1000",
        },
      },
      searchPlaceholder: "இங்கே தேடுங்கள்...",
      ageFilter: "வயது",
      casteFilter: "சாதி",
      locationFilter: "இடம்",
      sortBy: "வரிசைப்படுத்து",
      sortAZ: "A - Z",
      sortZA: "Z - A",
      profileDetails: "சுயவிவர விவரங்கள்",
      notSpecified: "குறிப்பிடப்படவில்லை",
      personalDetails: "தனிப்பட்ட விவரங்கள்",
      name: "பெயர்",
      matrimonyId: "திருமண ஐடி",
      age: "வயது",
      gender: "பாலினம்",
      dateOfBirth: "பிறந்த தேதி",
      height: "உயரம்",
      weight: "எடை",
      email: "மின்னஞ்சல்",
      phone: "தொலைபேசி எண்",
      motherTongue: "தாய்மொழி",
      native: "பூர்வீகம்",
      religion: "மதம்",
      caste: "சாதி",
      subCaste: "துணைச்சாதி",
      bloodGroup: "இரத்த வகை",
      familyProfessionalDetails: "குடும்ப மற்றும் தொழில்முறை விவரங்கள்",
      fatherName: "தந்தையின் பெயர்",
      motherName: "தாயின் பெயர்",
      fatherOccupation: "தந்தையின் தொழில்",
      motherOccupation: "தாயின் தொழில்",
      siblingCount: "உடன்பிறந்தோர் எண்ணிக்கை",
      occupation: "தொழில்",
      annualIncome: "ஆண்டு வருமானம்",
      education: "கல்வி",
      company: "நிறுவனம்",
      workLocation: "பணி இடம்",
      workCountry: "பணி நாடு",
      horoscopeDetails: "ஜாதக விவரங்கள்",
      nakshatra: "நட்சத்திரம்",
      rashi: "ராசி",
      ascendent: "லக்னம்",
      birthTime: "பிறந்த நேரம்",
      birthPlace: "பிறந்த இடம்",
      preferences: "விருப்பங்கள்",
      preferredAgeRange: "விருப்பமான வயது வரம்பு",
      preferredHeightRange: "விருப்பமான உயர வரம்பு",
      preferredReligion: "விருப்பமான மதம்",
      preferredCaste: "விருப்பமான சாதி",
      preferredSubCaste: "விருப்பமான துணைச்சாதி",
      preferredStatus: "விருப்பமான நிலை",
      preferredLocation: "விருப்பமான இடம்",
      documents: "ஆவணங்கள்",
      viewHoroscopeDocument: "ஜாதக ஆவணம் {index} ஐ பார்க்கவும்",
      noHoroscopeDocuments: "ஜாதக ஆவணங்கள் இல்லை.",
      contactUs: "எங்களைத் தொடர்பு கொள்ளவும்",
      sendMessage: "செய்தியை அனுப்பவும்",
      contact: {
        placeholders: {
          name: "உங்கள் பெயரை உள்ளிடவும்",
          email: "உங்கள் மின்னஞ்சலை உள்ளிடவும்",
          description: "உங்கள் செய்தியை உள்ளிடவும்",
          mobile: "உங்கள் தொலைபேசி எண்ணை உள்ளிடவும்",
        },
        errors: {
          nameRequired: "பெயர் தேவை",
          mobileRequired: "தொலைபேசி எண் தேவை",
          mobileInvalid: "தொலைபேசி எண் 10 இலக்கங்களாக இருக்க வேண்டும்",
          emailRequired: "மின்னஞ்சல் தேவை",
          emailInvalid: "தவறான மின்னஞ்சல் முகவரி",
          descriptionRequired: "விவரிப்பு தேவை",
        },
      },
      insufficientPoints:
        "இந்த சுயவிவரத்தைப் பார்க்க உங்களிடம் புள்ளிகள் போதுமானதாக இல்லை. இந்த சுயவிவரத்தைத் திறக்க, தயவுசெய்து புள்ளிகளை மறுசார்ஜ் செய்யவும்!",
      goToRecharge: "மறுசார்ஜ் செய்ய செல்லவும்",
      fetchFavoritesError: "பிடித்த சுயவிவரங்களைப் பெற முடியவில்லை",
      pointsSpentSuccess:
        "புள்ளிகள் வெற்றிகரமாக செலவிடப்பட்டன! சுயவிவரம் திறக்கப்பட்டது.",
      pointsSpentError: "புள்ளிகள் செலவு பிழை: {error}",
      fetchPointsError: "புள்ளிகளைப் பெறுவதில் பிழை",
      moreDetails: "மேலும் விவரங்கள்",
      viewDetails: "விவரங்களைப் பார்",
      location: "இடம்",
      viewed: "பார்க்கப்பட்டது",

      // Navbar translations
      home: "முகப்பு",
      matchingProfiles: "பொருத்தமான சுயவிவரங்கள்",
      favourites: "பிடித்தவை",
      aboutus: "எங்களைப் பற்றி",
      howits: "இது எவ்வாறு செயல்படுகிறது",
      contactUs: "எங்களை தொடர்பு கொள்ளுங்கள்",
      logout: "வெளியேறு",
      settings: "அமைப்புகள்",
      settings: {
        settingstitle: "அமைப்புகள்",
        profileSettings: "சுயவிவர அமைப்புகள்",
        name: "பெயர்",
        enterName: "உங்கள் பெயரை உள்ளிடவும்",
        email: "மின்னஞ்சல்",
        enterEmail: "உங்கள் மின்னஞ்சலை உள்ளிடவும்",
        updateProfile: "சுயவிவரத்தைப் புதுப்பிக்கவும்",
        notificationSettings: "அறிவிப்பு அமைப்புகள்",
        emailNotifications: "மின்னஞ்சல் அறிவிப்புகள்",
        pushNotifications: "புஷ் அறிவிப்புகள்",
        securitySettings: "பாதுகாப்பு அமைப்புகள்",
        changePassword: "கடவுச்சொல்லை மாற்றவும்",
        newPassword: "புதிய கடவுச்சொல்",
        enterNewPassword: "புதிய கடவுச்சொல்லை உள்ளிடவும்",
        confirmPassword: "கடவுச்சொல்லை உறுதிப்படுத்தவும்",
        confirmPasswordPlaceholder: "உங்கள் கடவுச்சொல்லை மீண்டும் உள்ளிடவும்",
        updatePassword: "கடவுச்சொல்லைப் புதுப்பிக்கவும்",
        languageSettings: "மொழி அமைப்புகள்",
        selectLanguage: "மொழியைத் தேர்ந்தெடுக்கவும்",
        currentLanguage: "தற்போதைய மொழி",
        passwordMismatch: "கடவுச்சொற்கள் பொருந்தவில்லை",
        profileUpdateSuccess: "சுயவிவரம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
        profileUpdateError: "சுயவிவரத்தைப் புதுப்பிக்க முடியவில்லை",
        passwordUpdateSuccess: "கடவுச்சொல் வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
        passwordUpdateError: "கடவுச்சொல்லைப் புதுப்பிக்க முடியவில்லை",
      },
      myProfile: "எனது சுயவிவரம்",
      contactFormSuccess: "தொடர்பு படிவம் வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது",
      contactFormError: "தொடர்பு படிவத்தை சமர்ப்பிக்க முடியவில்லை",

      // Dashboard translations
      fetchProfilesError: "சுயவிவரங்களைப் பெற முடியவில்லை",
      fetchPreferencesError: "விருப்ப சுயவிவரங்களைப் பெற முடியவில்லை",
      fetchLocationPreferencesError:
        "இட விருப்ப சுயவிவரங்களைப் பெற முடியவில்லை",
      reportSuccess: "சுயவிவரம் வெற்றிகரமாக புகாரளிக்கப்பட்டது",
      reportError: "சுயவிவரத்தை புகாரளிக்க முடியவில்லை",
      noProfilesFound: "சுயவிவரங்கள் எதுவும் கிடைக்கவில்லை",
      reportReasonPlaceholder:
        "இந்த சுயவிவரத்தை புகாரளிப்பதற்கான காரணத்தை வழங்கவும்",
      report: "புகாரளி",
      reportProfile: "சுயவிவரத்தை புகாரளி",
      newProfiles: "புதிய சுயவிவரங்கள்",
      allProfiles: "அனைத்து சுயவிவரங்கள்",
      preferenceByRashi: "நட்சத்திர அடிப்படையில் விருப்பம்",
      preferenceByLocation: "இட அடிப்படையில் விருப்பம்",
      defaultProfiles: "இயல்புநிலை சுயவிவரங்கள்",
      favoriteUpdateError: "பிடித்தவைகளை புதுப்பிக்க முடியவில்லை",

      // AboutUs translations
      about: {
        title: "என்பிஎஸ் பற்றி",
        welcome:
          "நியூ பிருந்தா ஸ்டுடியோவுக்கு வரவேற்கிறோம், இங்கு பாரம்பரியம் தொழில்நுட்பத்தை சந்திக்கிறது. ஒரு முன்னணி திருமண தளமாக, நம்பிக்கை, வெளிப்படைத்தன்மை மற்றும் எளிமையுடன் உங்களுக்கு சரியான வாழ்க்கைத் துணையைக் கண்டுபிடிக்க உதவுவதில் நாங்கள் உறுதியாக இருக்கிறோம்.",
        missionVision: "எங்கள் பணி & பார்வை",
        mission:
          "வாழ்நாள் முழுவதும் உறவுகளை வளர்க்கும் பாதுகாப்பான, பயனர் நட்பு மற்றும் கலாச்சார ரீதியான திருமண தளத்தை வழங்குவதே எங்கள் பணி. திருமணத்தின் புனிதமான பிணைப்பில் நாங்கள் நம்பிக்கை கொண்டுள்ளோம் மற்றும் ஒவ்வொரு இணைப்பையும் அர்த்தமுள்ளதாக மாற்ற முயற்சிக்கிறோம்.",
        vision:
          "தொடர்ந்து புதுமைப்படுத்துவதன் மூலம் மற்றும் எங்கள் உறுப்பினர்களுக்கு மதிப்பை வழங்குவதன் மூலம் திருமணத் தொழிலில் மிகவும் நம்பப்படும் பெயராக மாறுவதே எங்கள் பார்வை.",
        whyChoose: "ஏன் என்பிஎஸ்-ஐ தேர்வு செய்ய வேண்டும்?",
        features: {
          verifiedProfiles: {
            title: "சரிபார்க்கப்பட்ட சுயவிவரங்கள்",
            desc: "எங்கள் அனைத்து பயனர்களுக்கும் பாதுகாப்பு மற்றும் நம்பகத்தன்மையை உறுதி செய்ய ஒவ்வொரு சுயவிவரமும் முழுமையாக சரிபார்க்கப்படுகிறது.",
          },
          communityFocused: {
            title: "சமூக-சார்ந்த",
            desc: "கலாச்சார ரீதியாக பொருந்தக்கூடிய துணையைக் கண்டுபிடிப்பதற்கு உதவ சமூகம் மற்றும் மதம் சார்ந்த பொருத்தங்களில் நாங்கள் நிபுணத்துவம் பெற்றுள்ளோம்.",
          },
          globalReach: {
            title: "உலகளாவிய அணுகல்",
            desc: "நீங்கள் இந்தியாவில் இருந்தாலும் அல்லது வெளிநாட்டில் இருந்தாலும், என்பிஎஸ் உங்களை உலகளவில் உள்ள சாத்தியமான துணைகளுடன் இணைக்கிறது.",
          },
          personalizedSupport: {
            title: "தனிப்பயனாக்கப்பட்ட ஆதரவு",
            desc: "உங்கள் ஆத்ம துணையைக் கண்டுபிடிப்பதற்கான உங்கள் பயணத்தில் உதவ எங்கள் அர்ப்பணிக்கப்பட்ட ஆதரவு குழு எப்போதும் தயாராக உள்ளது.",
          },
        },
        coreValues: "எங்கள் முக்கிய மதிப்புகள் & பார்வை",
        coreValuesText:
          "என்பிஎஸ் மேட்ரிமோனியில், நம்பிக்கை, நேர்மை மற்றும் உண்மையான இணைப்புகள் மூலம் மக்களை ஒன்றிணைக்கும் ஒரு தெளிவான நோக்கத்தால் நாங்கள் இயக்கப்படுகிறோம். திருமணம் செய்து கொள்வதற்கு அப்பாற்பட்ட எங்கள் பார்வை; ஒரு வாழ்க்கைத் துணையைக் கண்டுபிடிப்பது ஒரு சக்திவாய்ந்த மற்றும் மகிழ்ச்சியான பயணமாக இருக்கும் எதிர்காலத்தை உருவாக்க நாங்கள் நோக்கமாகக் கொண்டுள்ளோம்.",
        valuesList: {
          integrity:
            "முதலில் நேர்மை: நாம் செய்யும் ஒவ்வொன்றிலும் நேர்மையையும் வெளிப்படைத்தன்மையையும் நாங்கள் கடைப்பிடிக்கிறோம்.",
          customerCentric:
            "வாடிக்கையாளர்-மைய அணுகுமுறை: உங்கள் மகிழ்ச்சி எங்கள் முதன்மையான முன்னுரிமை, மற்றும் எங்கள் குழு உங்களுக்கு உதவ எப்போதும் தயாராக உள்ளது.",
          innovation:
            "புதுமை மற்றும் வளர்ச்சி: புத்திசாலித்தனமான கருவிகள் மற்றும் ஒரு Seamless பயனர் அனுபவத்தை வழங்க தொடர்ந்து உருவாகிறோம்.",
        },
        testimonials: "எங்கள் பயனர்கள் என்ன சொல்கிறார்கள்",
        testimonialsData: {
          testimonial1: {
            text: "என்பிஎஸ்-க்கு நன்றி, 3 மாதங்களுக்குள் என் ஆத்ம துணையைக் கண்டேன். இந்த தளம் சுத்தமான, பாதுகாப்பான மற்றும் மிகவும் பயனர் நட்பு!",
            author: "அஜீத் & ஷிவானி, பெங்களூர்.",
          },
          testimonial2: {
            text: "நாங்கள் என்பிஎஸ் மூலம் சந்தித்தோம் மற்றும் உடனடியாக இணைந்தோம். அவர்களின் திருமண முறை உண்மையில் பயனுள்ளதாகவும் தனியுரிமைக்கு மரியாதை கொடுப்பதாகவும் உள்ளது.",
            author: "பிரவீன் & சுஜி, சென்னை.",
          },
          testimonial3: {
            text: "பல தளங்களை முயற்சித்த பிறகு, என்பிஎஸ் அதன் சுத்தமான வடிவமைப்பு மற்றும் உண்மையான சுயவிவரங்களுடன் தனித்து நின்றது. நாங்கள் என்றென்றும் நன்றியுள்ளவர்கள்!",
            author: "ஸ்ரீநாத் & பிரவீன், கோயம்புத்தூர்.",
          },
        },
        ctaTitle: "உங்கள் பயணத்தைத் தொடங்க தயாரா?",
        ctaText:
          "இன்றே என்பிஎஸ்-இல் சேர்ந்து உங்கள் சரியான துணையைக் கண்டுபிடிப்பதற்கான முதல் படியை எடுக்கவும்.",
      },

      // ChatWidget translations
      chat: {
        title: "நிர்வாகி உரையாடல்",
        loginPrompt: "உரையாடலை அணுக உள்நுழையவும்",
        welcomeMessage:
          "வரவேற்கிறோம்! நிர்வாகியுடன் உரையாட ஒரு செய்தியை அனுப்பவும்.",
        inputPlaceholder: "உங்கள் செய்தியை தட்டச்சு செய்யவும்...",
        connectionStatus: {
          connected: "இணைக்கப்பட்டது",
          connecting: "இணைக்கிறது...",
          error: "மறு இணைப்பு செய்கிறது...",
          disconnected: "துண்டிக்கப்பட்டது",
        },
      },

      // LoginForm.jsx translations
      approved: "அனுமதி",
      pending: "நிராகரிக்கப்பட்டது ",
      loginMessage: "உங்கள் சரியான வரன்களை கண்டறிய உள்நுழைக",
      matrimonyId: "மேட்ரிமோனி ஐடி",
      matrimonyIdPlaceholder: "உங்கள் மேட்ரிமோனி ஐடியை உள்ளிடவும்",
      password: "கடவுச்சொல்",
      passwordPlaceholder: "உங்கள் கடவுச்சொல்லை உள்ளிடவும்",
      loginButton: "உள்நுழைக",
      noAccount: "கணக்கு இல்லையா?",
      register: "பதிவு செய்யவும்",
      successMessage:
        "உள்நுழைவு வெற்றிகரமாக உள்ளது! திருப்பி வழிநடத்தப்படுகிறது...",
      errorMessage:
        "மேட்ரிமோனி ஐடி அல்லது கடவுச்சொல்லை சரிபார்க்கவும் மீண்டும் முயற்சிக்கவும்.",
      formError: "படிவத்தில் உள்ள பிழைகளை சரிசெய்யவும்.",
      close: "மூடு",
      switchLanguage: "மொழி மாற்று",
      mobileLogin: "மொபைல் எண் மூலம் உள்நுழையவும்",
      passwordRequired: "கடவுச்சொல் தேவை",
      invalidPassword:
        "கடவுச்சொல் குறைந்தது 8 எழுத்துகள் மற்றும் எண்கள் இருக்க வேண்டும்",
      matrimonyIdRequired: "மேட்ரிமோனி ஐடி தேவை",
      invalidMatrimonyId: "தவறான மேட்ரிமோனி ஐடி",
      forgotPassword: "கடவுச்சொல் மறந்துவிட்டீர்களா?",
      resetPassword: "கடவுச்சொல்லை மீட்டமைக்க",
      backToLogin: "உள்நுழைய மீண்டும் செல்லவும்",
      email: "மின்னஞ்சல்",
      emailPlaceholder: "உங்கள் மின்னஞ்சலை உள்ளிடவும்",
      emailRequired: "மின்னஞ்சல் தேவை",
      invalidEmail: "தவறான மின்னஞ்சல் முகவரி",
      newPassword: "புதிய கடவுச்சொல்",
      newPasswordPlaceholder: "புதிய கடவுச்சொல்லை உள்ளிடவும்",
      confirmPassword: "கடவுச்சொலை உறுதிப்படுத்தவும்",
      confirmPasswordPlaceholder: "கடவுச்சொல்லை மீண்டும் உள்ளிடவும்",
      passwordsNotMatch: "கடவுச்சொற்கள் பொருந்தவில்லை",
      verifyEmail: "மின்னஞ்சலை சரிபார்க்கவும்",
      emailVerifiedMessage:
        "மின்னஞ்சல் சரிபார்க்கப்பட்டது! தயவுசெய்து உங்கள் புதிய கடவுச்சொல்லை உள்ளிடவும்.",
      emailNotRegistered: "இந்த மின்னஞ்சல் பதிவு செய்யப்படவில்லை",
      passwordResetSuccess: "கடவுச்சொல் வெற்றிகரமாக மீட்டமைக்கப்பட்டது!",
      passwordMismatch: "கடவுச்சொற்கள் பொருந்தவில்லை",
      passwordResetError: "கடவுச்சொல்லை மீட்டமைக்கும் போது பிழை ஏற்பட்டது",
      emailVerifySuccess: "மின்னஞ்சல் சரிபார்க்கப்பட்டது!",

      // MobileVerification.jsx translations
      mobileVerification: "மொபைல் சரிபார்ப்பு",
      enterFullName: "முழு பெயரை உள்ளிடவும்",
      enterMobileNumber: "மொபைல் எண்ணை உள்ளிடவும்",
      verifyMobile: "மொபைலை சரிபார்க்கவும்",
      resendOtp: "OTP ஐ மீண்டும் அனுப்பவும்",
      enterOtp: "OTP ஐ உள்ளிடவும்",
      submitOtp: "OTP ஐ சமர்ப்பிக்கவும்",
      otpSent: "உங்கள் மொபைல் எண்ணுக்கு OTP அனுப்பப்பட்டது!",
      mobileVerified: "மொபைல் எண் வெற்றிகரமாக சரிபார்க்கப்பட்டது! 🎉",
      invalidMobile:
        "தயவுசெய்து செல்லுபடியாகும் 10 இலக்க மொபைல் எண்ணை உள்ளிடவும்",
      invalidOtp: "தயவுசெய்து செல்லுபடியாகும் 4 இலக்க OTP ஐ உள்ளிடவும்",
      errorFullName: "தயவுசெய்து உங்கள் முழு பெயரை உள்ளிடவும்",
      errorMobileNumber:
        "தயவுசெய்து செல்லுபடியாகும் 10 இலக்க மொபைல் எண்ணை உள்ளிடவும்",
      otpFailed: "OTP அனுப்புவதில் தோல்வி",
      tryAgain: "மீண்டும் முயற்சிக்கவும்.",
      otpError: "OTP அனுப்புவதில் பிழை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
      alreadyHaveAccount: "ஏற்கனவே கணக்கு உள்ளதா?",
      login: "உள்நுழையவும்",
      tagline: "தங்கள் துணையை தேடும் மக்கள்",
      loading: "ஏற்றப்படுகிறது...",
      favorites: "பிடித்தவை",
      reportReason: "அறிக்கையின் காரணம்",
      submitReport: "அறிக்கையை சமர்ப்பி",
      cancel: "ரத்துசெய்",

      confirmPointsSpend: "புள்ளிகள் செலவு உறுதிப்படுத்தவும்",
      spendPointsMessage:
        "இந்த சுயவிவரத்தைப் பார்க்க 500 புள்ளிகளைச் செலவிட விரும்புகிறீர்களா?",
      noThanks: "வேண்டாம், நன்றி",
      confirm: "உறுதிப்படுத்தவும்",
      pointsDeductionWarning:
        "இந்த செயல் உங்கள் இருப்பிலிருந்து {points} புள்ளிகளை கழிக்கும்.",
      viewAll: "எல்லாம் காண்க",
      sortAgeAsc: "Age (Low to High)", // Added
      sortAgeDesc: "Age (High to Low)",
      backToHome: "பின்னோக்கிச் செல்லுங்கள்",

      profileDetails: {
        profileDetails: "சுயவிவர விவரங்கள்",
        education: "கல்வி",
        ageGender: "வயது & பாலினம்",
        about: "பற்றி",
        aboutDescription:
          "வணக்கம்! நான் {{full_name}}, குடும்பத்தை மதிக்கும் மற்றும் அன்பில் நம்பிக்கை கொண்ட ஒரு அன்பான நபர். எனக்கு {{age}} வயது. குடும்பத்துடன் ஒரு கப் காபி பகிர்ந்து கொள்வது முதல் சிறப்பு நபருடன் புதிய சாகசங்களை மேற்கொள்வது வரை வாழ்க்கையின் சிறிய விஷயங்களை நான் ரசிக்கிறேன். அதே மதிப்புகளைப் பகிர்ந்து கொள்ளும் ஒரு துணையைச் சந்திக்க ஆவலாக உள்ளேன், மற்றும் ஒன்றாக அன்பும் மகிழ்ச்சியும் நிறைந்த எதிர்காலத்தை உருவாக்க முடியும்.",
        notSpecified: "குறிப்பிடப்படவில்லை",
        noInfo: "கூடுதல் தகவல் இல்லை.",
        close: "மூடு",
        language: "மொழி",
        noProfileData: "சுயவிவர தரவு எதுவும் கிடைக்கவில்லை.",
        
        //viewed: "பார்க்கப்பட்டது",

        // Added keys for profile actions
        active: "செயலில்",
        deactive: "செயலிழந்த",
        deactivateReason: "செயலிழப்பதற்கான காரணம்",
        deactivateProfile: "சுயவிவரத்தை செயலிழக்கச் செய்யவும்",
        deleteProfile: "சுயவிவரத்தை நீக்கவும்",
        deleteConfirm:
          "உங்கள் சுயவிவரத்தை நிச்சயமாக நீக்க விரும்புகிறீர்களா? இந்த செயல் மீட்க முடியாது.",
        deleteError: "சுயவிவரத்தை நீக்க முடியவில்லை",
        editPartnerPreferences: "பங்குதாரர் விருப்பங்களைத் திருத்தவும்",
        savePreferences: "விருப்பங்களைச் சேமிக்கவும்",
        editPersonalInformation: "தனிப்பட்ட தகவலைத் திருத்தவும்",
        saveInformation: "தகவலைச் சேமிக்கவும்",
        reasonRequired: "செயலிழப்பு காரணம் தேவை",
        male: "ஆண்",
        female: "பெண்",
        photo: "சுயவிவர புகைப்படம்",
      },
    },
  },
};

i18next
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem("language") || "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    debug: process.env.NODE_ENV === "development",
  })
  .then(() => {
    console.log("i18next initialized successfully");
  })
  .catch((error) => {
    console.error("i18next initialization failed:", error);
  });

export default i18next;
